'use strict';

import React, { Component } from 'react';
import { connect } from 'react-redux'
import Avatar from 'components/Avatar';
import ChatMedia from 'components/ChatMedia';
import GallaryCard from 'components/GallaryCard';
import CarouselComp from 'components/CarouselComp';
import { log } from 'utils';
import zChat from 'vendor/web-sdk';
import Combobox from 'react-widgets/lib/Combobox';
import Interweave from 'interweave';
import config from 'config';
const {BOT_ID} = config;
// import "react-widgets/dist/css/react-widgets.css";

class ChatMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMore : false,
      isPrev : false,
      index: 0,
      disabledNext: false,
      disabledPrev: true,
      errMsg: false
    };
    this.getClassName = this.getClassName.bind(this);
    this.renderMessagePart = this.renderMessagePart.bind(this);
    this.renderGallaryCards = this.renderGallaryCards.bind(this);
    this.renderMessage = this.renderMessage.bind(this);
    this.renderOptions = this.renderOptions.bind(this);
    this.optionOnChange = this.optionOnChange.bind(this);
    this.optionOnSelect = this.optionOnSelect.bind(this);
    this.createDropDownList = this.createDropDownList.bind(this);
    this.addMargin = this.addMargin.bind(this);
    this.hyperLink = this.hyperLink.bind(this);
    this.isMoreButton = this.isMoreButton.bind(this);
    this.isPrevButton = this.isPrevButton.bind(this);
    // this.removePreviousSuggestion = this.removePreviousSuggestion.bind(this);
  }

  getClassName(msg) {
    return msg.member_type;
  }

  hyperLink(msg){
    let renderMsg = ''
    let regexHyper = RegExp(/http[s]?:\/\//gm);
      let msgList = msg.split(' ');
      for(let i = 0 ; i< msgList.length ; i++){
        if(regexHyper.test(msgList[i])){
          renderMsg += `<a href="${msgList[i]}" target="_blank" >${msgList[i]}</a>`
        }
        else
          renderMsg = renderMsg + ' ' + msgList[i]
      }

      return renderMsg;
  }

  optionOnChange(e) {
    const msg = e.currentTarget.value;
    e.target.parentElement.style.display = 'none';
    zChat.sendChatMsg(msg, (err) => {
      if (err) {
        log('Error occured >>>', err);
        return;
      }
      this.props.dispatch({
        type: 'synthetic',
        detail: {
          type: 'visitor_send_msg',
          msg
        }
      });
    });

  }

  optionOnSelect(e) {

    let selectedValue = e.currentTarget.parentNode.getElementsByTagName('input')[0].value;
    const optionsArray = this.props.message.options;
    const matchElement = optionsArray.some((element) => {
      return (element.toLowerCase() == selectedValue.toLowerCase()) ? (selectedValue = element) : false
    });

    if(!matchElement) {
      this.setState({errMsg:true});
      return;
    } else {
      this.setState({errMsg:false});
    }

    const msg = selectedValue;

    zChat.sendChatMsg(msg, (err) => {
      if (err) {
        log('Error occured >>>', err);
        return;
      }
      this.props.dispatch({
        type: 'synthetic',
        detail: {
          type: 'visitor_send_msg',
          msg
        }
      });
    });

  }

addMargin(value){
  if(value === 0) return '0';
  else return '6px'
}

  renderMessage(msg) {
    if(msg === 'failed to load template') {
      return;
    }
    else if (msg === 'undefined') return;
    else {
      let regexHyper = RegExp(/.*http[s]?:\/\/.*/gm);
      if(regexHyper.test(msg) && !msg.includes('</a>') )
        msg = this.hyperLink(msg)
      msg = msg.replace('&lt;br&gt;' , '<br>')
      // console.log(msg)
      let msgList = msg.split('&lt;newMessage&gt;');
      // console.log(msgList)
      if(msgList.length === 1 )
      return (
        <div className={`chat-msg ebcss-chat-conversation-msg ${this.getClassName(this.props.message)+'-content-fit'}`}>
          <Interweave content={msgList[0]} />
        </div>
      )
      else {
  return   msgList.map((msg1,index)=>{
  return (
    <div key={index} className="chat-msg ebcss-chat-conversation-msg" style={{marginTop : this.addMargin(index) }}>
    {/* <span dangerouslySetInnerHTML={{__html: msg}}/> */}
    <Interweave content={msg1} />
  </div>
  )
})
      }
    }
  }

  createDropDownList(dropDownlList) {
    if(dropDownlList.indexOf('Cancel') != -1) {
      dropDownlList.pop();
    }

    let classes = 'ebcss-dropdown-errMsg';
    classes += this.state.errMsg ? ' show-dropDown-errmsg' : '';
    let messagesOptions = {
      emptyFilter : 'Suche hat kein Ergebnis'
    }
    return (
      <div className="ebcss-dropDown-list-container">
        <div className="ebcss-drop-down-box">
          {/* <input type="text" name="search-input" className="autocomplete-search-input" /> */}
          <Combobox
            data={dropDownlList}
            defaultValue={dropDownlList[0]}
            textField='text'
            caseSensitive={false}
            minLength={1}
            filter='contains'
            messages={messagesOptions}
          />
          <span className={classes}> Bitte wählen Sie die richtige Option </span>
          <button className="ebcss-dropDown-submit-button"  onClick={this.optionOnSelect}>SENDEN</button>
        </div>
      </div>
    )
  }
isMoreButton() {
  let index = this.state.index + 3;
  let disabledNext = (this.props.message.options.length - index) <= 3 ;
  try {
    let lastMessage = document.getElementById('msgWrapper').lastChild;
    lastMessage.style.scrollMarginBottom = '16px';
    setTimeout(() => {
      lastMessage.scrollIntoView(true);
    }, 30);
  } catch (e) {
    console.log('error', e);
  }
  this.setState({ index: index, disabledNext: disabledNext, disabledPrev: false })
}

isPrevButton(){
  let index = this.state.index - 3;
  let disabledPrev = (index === 0);

  this.setState({ index: index, disabledPrev: disabledPrev, disabledNext: false })
}
  renderOptions(options) {
    if(this.props.message.msg === 'failed to load template') {
      return;
    } else if(this.props.message.structured_msg && this.props.message.structured_msg.msg && this.props.message.structured_msg.msg  === 'DROPDOWN_LIST' ) {

      return (
        this.createDropDownList(options)
      )
    } else if (!options || options.length <= 0) return;

    if(options.length<=5){
      return(<div>
      {
        options.map((option, i) => {
          return (
              <input key={`options-${i}`} type="button" name="option" data-id={i} value={option} onClick={this.optionOnChange} style={{ margin : '10px 24px'}}/>
          );
        })
      }
      </div>);
    }
    else{
      const options_copy = options.slice(this.state.index, this.state.index+3)
      return (
        <div>
            {!this.state.disabledPrev && <input
             className = "more_prev_options"
              type="button"
              name="option"
              value="Vorherige Optionen &#x25B2;"
              onClick={this.isPrevButton}
              style={{ margin : '10px 24px'}}
            />}
          {options_copy.map((option, i) => {
            // if (i <= 3) {
              return (
                <input
                  className = "chat-suggestion-options"
                  key={i}
                  type="button"
                  name="option"
                  data-id={i}
                  value={option}
                  onClick={this.optionOnChange}
                  style={{ margin : '10px 24px'}}
                />
              );
            // }
          })}
         {!this.state.disabledNext && <input
             className = "more_prev_options"
            type="button"
            name="option"
            value="Mehr Optionen &#x25BC;"
            onClick={this.isMoreButton}
            style={{ margin : '10px 24px'}}
          />}
        </div>
      );
    }
  }

  renderGallaryCards(cardsDatas) {

    // log('ChatMessage',cardsDatas);

    if(cardsDatas.type === 'PANEL_TEMPLATE_CAROUSEL') {

      let cardsDatasArray = [];
      
      cardsDatasArray = cardsDatas.items;

      return (
        <div className="ebcss-cards-carousel-conatiner" style = { cardsDatasArray[0].panel.heading !== 'null' ? { minHeight : '100%'}: {} }>
          <CarouselComp messageArray={cardsDatasArray} />
        </div>
      )

    } else if(cardsDatas.type === 'PANEL_TEMPLATE') {

      return (
        <div>
            <GallaryCard message={cardsDatas} />
        </div>
      )

    } else if(!cardsDatas && cardsDatas.type === 'QUICK_REPLIES') return;

  }

  renderMessagePart(msg) {
    switch (msg.type) {
      case 'chat.file':
        return <ChatMedia message={msg} />;
      default:
        log('ChatMessage',msg,this.props.message.msg);
        if(msg && msg.nick.split(':')[1] === 'offline'){
          return;
        }
        return (
          <div style={{display : 'flex' ,  flexDirection : 'column'}}>
            {this.renderMessage(this.props.message.msg)}
            {
              this.props.message.structured_msg ? this.props.message.structured_msg.msg ? '' : this.renderGallaryCards(this.props.message.structured_msg) : ''
              // this.renderGallaryCards(this.props.message.structured_msg)
            }
            <div className="chat-options">
              {this.renderOptions(this.props.message.options)}
            </div>
          </div>
        );
    }
  }

  render() {
    if(this.props.message && this.props.message.nick){
      let nick = this.props.message.nick;
      if(nick.split(':').length == 2 && nick.split(':')[1].toString() !== BOT_ID.toString() && nick.split(':')[1] !== 'offline'){
        if(document.getElementById('msgWrapper') && document.getElementById('msgWrapper').lastChild){
          let prevMsg = document.getElementById('msgWrapper').lastChild;
   
         if(prevMsg.classList.contains('system-msg-container')){
          if(prevMsg.previousSibling){
            let currNode = prevMsg.previousSibling;
  
            while(currNode && currNode.classList.contains('system-msg-container')){
              currNode = currNode.previousSibling;
            }
            if(currNode && currNode.querySelector('.chat-options')){
              currNode.querySelector('.chat-options').style.display = 'none';
            }
          }
         }
          if(prevMsg && prevMsg.querySelector('.chat-options')){
              prevMsg.querySelector('.chat-options').style.display = 'none';
  
          }
        }
      }
    }

    if(this.getClassName(this.props.message) == 'visitor'){
      if(document.getElementById('msgWrapper').lastChild){
        let prevMsg = document.getElementById('msgWrapper').lastChild;
 
       if(prevMsg.classList.contains('system-msg-container')){
        if(prevMsg.previousSibling){
          let currNode = prevMsg.previousSibling;

          while(currNode && currNode.classList.contains('system-msg-container')){
            currNode = currNode.previousSibling;
          }
          if(currNode && currNode.querySelector('.chat-options')){
            currNode.querySelector('.chat-options').style.display = 'none';
          }
        }
       }
        if(prevMsg && prevMsg.querySelector('.chat-options')){
            prevMsg.querySelector('.chat-options').style.display = 'none';

        }
      }
    }
    return (
      <div className={`chat-msg-container ${this.getClassName(this.props.message)} ${this.props.addClass}`} ref={this.getClassName(this.props.message) === 'agent' ? 'AgentNode' : ''} >
        <div className="avatar-container">
          <Avatar entity={this.props.agent} />
        </div>
        <div className="chat-msg-wrapper">
          {this.renderMessagePart(this.props.message)}
        </div>
      </div>
    );
  }
}

ChatMessage.displayName = 'ChatMessage';
ChatMessage.propTypes = {
  message: React.PropTypes.object,
  agent: React.PropTypes.object,
  addClass: React.PropTypes.string
};
ChatMessage.defaultProps = {
  message: {
    msg: ''
  }
}

export default connect()(ChatMessage);


// WEBPACK FOOTER //
// ./src/components/ChatMessage.js